function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useQuery } from '@apollo/client';
import Async from './';
import { chainedDataIndexExtractor } from '../../../../common/utils/chainedDataIndex';

const Graph = ({
  gql,
  queryKey,
  labelKey,
  valueKey,
  manageData,
  manageOptions,
  filterOptions,
  manageVariables,
  defaultVariables: variables,
  fetchPolicy,
  ...props
}) => {
  const request = useQuery(gql, {
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
    variables
  });
  return /*#__PURE__*/React.createElement(Async, _extends({}, props, {
    loadOptions: text => {
      return request.refetch(manageVariables(text)).then(response => {
        let data = response.data && response.data[queryKey];

        if (!!manageData) {
          return manageData(data);
        }

        if (!!filterOptions) {
          data = data.filter(filterOptions);
        }

        return data.map((each, index) => {
          if (typeof manageOptions === 'function') {
            return manageOptions(each, index);
          }

          return {
            label: chainedDataIndexExtractor(labelKey, each),
            value: chainedDataIndexExtractor(valueKey, each)
          };
        });
      });
    }
  }));
};

Graph.defaultProps = {
  queryKey: 'dropdown',
  labelKey: 'label',
  valueKey: 'value',
  fetchPolicy: 'no-cache'
};
export default Graph;